import { render, staticRenderFns } from "./PintuanCreate.vue?vue&type=template&id=0fa7273c&scoped=true"
import script from "./PintuanCreate.vue?vue&type=script&lang=js"
export * from "./PintuanCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7273c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa7273c')) {
      api.createRecord('0fa7273c', component.options)
    } else {
      api.reload('0fa7273c', component.options)
    }
    module.hot.accept("./PintuanCreate.vue?vue&type=template&id=0fa7273c&scoped=true", function () {
      api.rerender('0fa7273c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/PintuanCreate.vue"
export default component.exports